import React from "react";
import { Header, Icon, Table, Form, Button, Label } from "semantic-ui-react";
import PermissionsManager from "../PermissionsManager";
import Unauthorized from "../Unauthorized";
import UploadNewsletterCSV from "../UploadNewsletterCSV";

const NewsletterSubscribers = ({ newsletterSubscribers, onDelete, status }) => {
  const permissions = localStorage.getItem("permissions");
  if (permissions.indexOf("get_newsletter_subscribers") === -1) {
    return <Unauthorized></Unauthorized>;
  }

  if (!newsletterSubscribers || newsletterSubscribers.length === 0) {
    return (
      <div>
        <Header as="h1">Abonnés à la newsletter</Header>
        <br />
        Aucun enregistrement
      </div>
    );
  }

  return (
    <div>
      <Header as="h1">Abonnés à la newsletter</Header>
      <UploadNewsletterCSV />
      <Table selectable singleLine color="red">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Email</Table.HeaderCell>
            <Table.HeaderCell>Inscription validée ?</Table.HeaderCell>
            <PermissionsManager hasPermissions={["delete_newsletter_subscriber"]}>
              <Table.HeaderCell textAlign="right">Action</Table.HeaderCell>
            </PermissionsManager>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {newsletterSubscribers.map(newsletterSubscriber => {
            return (
              <Table.Row key={newsletterSubscriber.id}>
                <Table.Cell>{newsletterSubscriber.email}</Table.Cell>
                <Table.Cell>
                  <Label color={newsletterSubscriber.enabled ? "green" : "red"} horizontal>
                    {newsletterSubscriber.enabled ? "Oui" : "Non"}
                  </Label>
                </Table.Cell>
                <PermissionsManager hasPermissions={["delete_newsletter_subscriber"]}>
                  <Table.Cell textAlign="right">
                    <Form>
                      <div>
                        <Button
                          type="submit"
                          color="red"
                          floated="right"
                          className="button-icon"
                          onClick={(event, data) => {
                            onDelete(event, { confirm: false, id: newsletterSubscriber.id });
                          }}
                        >
                          <Icon name="delete" />
                        </Button>
                      </div>
                    </Form>
                  </Table.Cell>
                </PermissionsManager>
              </Table.Row>
            );
          })}
        </Table.Body>

        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan="3">
              <a href={`${process.env.REACT_APP_API_URL}/newsletter-subscribers.csv`}>
                <Icon name="download" /> Télécharger les abonnés au format CSV
              </a>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </div>
  );
};

export default NewsletterSubscribers;



// WEBPACK FOOTER //
// ./src/components/list/NewsletterSubscribers.js